module.exports = __webpack_public_path__ + "img/prize-04.f967e0ab.png";